import { http } from '@/api/http'

/**
 * 认证相关接口。
 *
 * 所有后端调用都收敛在 api 目录里，组件不直接写 URL。这么做在没有 TypeScript 的项目里
 * 尤其重要：接口路径或字段改名时，只要改这一处，而不是去全局搜字符串——
 * 没有编译器帮忙的时候，「改动范围可控」只能靠约束结构来换。
 */
export const authApi = {
  /**
   * 登录。
   *
   * @param {{ orgCode?: string | null, username: string, password: string }} credentials
   * @returns {Promise<{
   *   token: string,
   *   expiresInSeconds: number,
   *   userId: number,
   *   username: string,
   *   displayName: string,
   *   role: 'PLATFORM_ADMIN' | 'OWNER' | 'STAFF',
   *   orgId: number | null,
   *   orgName: string | null,
   *   orgLoginCode: string | null,
   *   locale: string,
   *   mustChangePassword: boolean
   * }>}
   */
  login(credentials) {
    return http.post('/auth/login', credentials)
  },

  /**
   * 老板自助注册：创建组织主体 + OWNER 账号，成功后直接返回登录态。
   *
   * @param {{
   *   orgName: string,
   *   username: string,
   *   password: string,
   *   displayName: string,
   *   locale?: string,
   *   contactPhone?: string | null
   * }} payload
   * @returns {Promise<{
   *   token: string,
   *   expiresInSeconds: number,
   *   userId: number,
   *   username: string,
   *   displayName: string,
   *   role: 'PLATFORM_ADMIN' | 'OWNER' | 'STAFF',
   *   orgId: number | null,
   *   orgName: string | null,
   *   orgLoginCode: string | null,
   *   locale: string,
   *   mustChangePassword: boolean
   * }>}
   */
  register(payload) {
    return http.post('/auth/register', payload)
  },

  /**
   * 取当前登录用户。用于刷新页面后确认 token 是否仍然有效。
   *
   * @returns {Promise<{
   *   userId: number,
   *   username: string,
   *   displayName: string,
   *   role: 'PLATFORM_ADMIN' | 'OWNER' | 'STAFF',
   *   orgId: number | null,
   *   mustChangePassword: boolean
   * }>}
   */
  me() {
    return http.get('/auth/me')
  },

  /**
   * 修改自己的密码。
   *
   * 注意没有 userId 参数——后端从 token 里取当前用户。让前端传 userId
   * 等于允许任何人改任何人的密码。
   *
   * @param {{ currentPassword: string, newPassword: string }} payload
   * @returns {Promise<void>}
   */
  changePassword(payload) {
    return http.post('/auth/change-password', payload)
  },
}
